import React from 'react';
import Contact from '../Components/ShareComponents/Contact';

const ContactPage = () => {
    // const contact = 499;
    return (
        <div>
             
            <Contact page='page' />
        </div>
    );
};

export default ContactPage;
